import React from 'react'
import { BsClock, BsStarFill } from 'react-icons/bs'
import { MdLanguage } from 'react-icons/md'
import Button from './Button'

const Service = (props) => {
    const { id, title, image, languages, time, rating ,price } = props

    return (
        <div className="bg-white rounded-lg shadow-lg p-2 overflow-hidden">
            <div className="rounded-lg overflow-hidden h-52 w-full">
                <img src={image} alt={id} className="object-cover h-full w-full transform transition duration-500 hover:scale-125" />
            </div>
            <h1 className="text-xl text-gray-700 font-medium py-2 font_poppins">{title}</h1>
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-1">
                    <BsStarFill className="text-yellow-500" />
                    <BsStarFill className="text-yellow-500" />
                    <BsStarFill className="text-yellow-500" />
                    <BsStarFill className="text-yellow-500" />
                    <BsStarFill className="text-yellow-500" />
                    <span className="text-sm text-gray-500">{rating}</span>
                </div>
                <p className="bg-indigo-700 text-white rounded-md px-2 py-1">
                    ${price}
                </p>
            </div>
            
            
            <div className="py-4 flex items-center justify-between">
                <span className="text-sm text-gray-500"><MdLanguage  className="text-indigo-700 text-lg mb-1" /> {languages}</span>
                <span className="text-sm text-gray-500"><BsClock className="text-indigo-700 text-lg mb-1" /> {time}</span>
            </div>
            <Button text="View Details" style={{width:"100%"}}/>
        </div>
    )
}

export default Service
